import React, { Component } from "react";
import ReportHeader from "../../../Report/ReportHeader";
import axios from "axios";
import Spinner from "../../../Common/Spinner";
import * as appConst from "../../../Common/constants";
import moment from "moment";

export default class Account extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cashEntries: "NA",
      receipts: "NA",
      payments: "NA",
      spinnerClass: "",
      dataClass: "collapse",
      openTotal: 0,
      closeTotal: 0,
      receiptsTotal: 0,
      paymentsTotal: 0
    };
  }

  componentDidMount() {
    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) + "/account/monthlyBalance",
        this.props.data
      )
      .then(res => {
        this.setState({
          cashEntries: res.data
        });
      });

    const obj = {
      txnType: "Income",
      fromDate: this.props.data.fromDate,
      toDate: this.props.data.toDate
    };

    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) + "/account/detailsReport",
        obj
      )
      .then(res => {
        this.setState({
          receipts: res.data
        });
      });

    const objExp = {
      txnType: "Expense",
      fromDate: this.props.data.fromDate,
      toDate: this.props.data.toDate
    };

    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) + "/account/detailsReport",
        objExp
      )
      .then(res => {
        this.setState({
          payments: res.data,
          spinnerClass: "collapse",
          dataClass: ""
        });
      });
  }

  tabCashEntries() {
    if (this.state.cashEntries !== "NA") {
      return this.state.cashEntries.cash.map(obj => {
        var openParts = obj.openingBal.toString().split(".");
        var open =
          openParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
          (openParts[1] ? "." + openParts[1] : ".00");
        var closeParts = obj.closingBal.toString().split(".");
        var close =
          closeParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
          (closeParts[1] ? "." + closeParts[1] : ".00");
        return (
          <div className="row" key={obj.bankName}>
            <div className="col col-md-6 border">{obj.bankName}</div>
            <div className="col col-md-3 border" align="right">
              {open}
            </div>
            <div className="col col-md-3 border" align="right">
              {close}
            </div>
          </div>
        );
      });
    }
  }

  tabCashEntriesTotal() {
    if (this.state.cashEntries !== "NA") {
      var openParts = this.state.cashEntries.openSum.toString().split(".");
      var open =
        openParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        (openParts[1] ? "." + openParts[1] : ".00");

      var closeParts = this.state.cashEntries.closeSum.toString().split(".");
      var close =
        closeParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        (closeParts[1] ? "." + closeParts[1] : ".00");

      return (
        <div className="row">
          <div className="col col-md-6 border">
            <h5>Total</h5>
          </div>
          <div className="col col-md-3 border" align="right">
            <h5>{open}</h5>
          </div>
          <div className="col col-md-3 border" align="right">
            <h5>{close}</h5>
          </div>
        </div>
      );
    }
  }

  tabReceipts() {
    if (this.state.receipts !== "NA") {
      return this.state.receipts.data.map(obj => {
        var amtParts = obj.totalAmount.toString().split(".");
        var amt =
          amtParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
          (amtParts[1] ? "." + amtParts[1] : ".00");

        return (
          <div className="row" key={obj._id.type + "-" + obj._id.txntype}>
            <div className="col col-md-6 border" align="left">
              {obj._id.type}
            </div>
            <div className="col col-md-6 border" align="right">
              {amt}
            </div>
          </div>
        );
      });
    }
  }

  tabReceiptsTotal() {
    if (this.state.receipts !== "NA") {
      var amtParts = this.state.receipts.totalAmount.toString().split(".");
      var amt =
        amtParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        (amtParts[1] ? "." + amtParts[1] : ".00");

      return (
        <div className="row">
          <div className="col col-md-6 border" align="left">
            <h5>Total</h5>
          </div>
          <div className="col col-md-6 border" align="right">
            <h5>{amt}</h5>
          </div>
        </div>
      );
    }
  }

  tabPayments() {
    if (this.state.payments !== "NA") {
      return this.state.payments.data.map(obj => {
        var totamt = obj.totalAmount * -1;
        var amtParts = totamt.toString().split(".");
        var amt =
          amtParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
          (amtParts[1] ? "." + amtParts[1] : ".00");

        return (
          <div className="row" key={obj._id.type + "-" + obj._id.txntype}>
            <div className="col col-md-6 border" align="left">
              {obj._id.type}
            </div>
            <div className="col col-md-6 border" align="right">
              {amt}
            </div>
          </div>
        );
      });
    }
  }

  tabPaymentsTotal() {
    if (this.state.payments !== "NA") {
      var amtParts = (this.state.payments.totalAmount * -1)
        .toString()
        .split(".");
      var amt =
        amtParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        (amtParts[1] ? "." + amtParts[1] : ".00");

      return (
        <div className="row">
          <div className="col col-md-6 border" align="left">
            <h5>Total</h5>
          </div>
          <div className="col col-md-6 border" align="right">
            <h5>{amt}</h5>
          </div>
        </div>
      );
    }
  }

  tabGrandTotal() {
    if (
      this.state.payments !== "NA" &&
      this.state.receipts !== "NA" &&
      this.state.cashEntries !== "NA"
    ) {
      var receiptsTotal =
        this.state.cashEntries.openSum + this.state.receipts.totalAmount;
      var paymentsTotal =
        this.state.cashEntries.closeSum + this.state.payments.totalAmount * -1;

      var recParts = receiptsTotal.toString().split(".");
      var recTotal =
        recParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        (recParts[1] ? "." + recParts[1] : ".00");

      var payParts = paymentsTotal.toString().split(".");
      var payTotal =
        payParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        (payParts[1] ? "." + payParts[1] : ".00");

      return (
        <div className="row">
          <div className="col col-md-3 border" align="left">
            <h4>Grand Total</h4>
          </div>
          <div className="col col-md-3 border" align="right">
            <h4>{recTotal}</h4>
          </div>
          <div className="col col-md-3 border" align="left">
            <h4>Grand Total</h4>
          </div>
          <div className="col col-md-3 border" align="right">
            <h4>{payTotal}</h4>
          </div>
        </div>
      );
    }
  }

  tabLedgerEntries() {
    if (this.state.cashEntries !== "NA") {
      return this.state.cashEntries.DailyLedger.map(obj => {

        var arr = obj.date.split("-");
        var displayDate = arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0];

        var incomeParts = obj.income.toString().split(".");
        var income =
          incomeParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
          (incomeParts[1] ? "." + incomeParts[1] : ".00");

        var expenseParts = obj.expense.toString().split(".");
        var expense =
          expenseParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
          (expenseParts[1] ? "." + expenseParts[1] : ".00");

        return (
          <div className="row" key={obj.date}>
            <div className="col col-md-2 border">{displayDate}</div>
            <div className="col col-md-2 border" align="right">
              {income}
            </div>
            <div className="col col-md-2 border" align="right">
              {expense}
            </div>
          </div>
        );
      });
    }
  }

  tabLedgerTotal() {
    if (this.state.cashEntries !== "NA") {
      var incomeParts = this.state.cashEntries.incomeTotal.toString().split(".");
      var income =
        incomeParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        (incomeParts[1] ? "." + incomeParts[1] : ".00");

      var expenseParts = this.state.cashEntries.expenseTotal.toString().split(".");
      var expense =
        expenseParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        (expenseParts[1] ? "." + expenseParts[1] : ".00");

      return (
        <div className="row" key='LedgerTotal'>
          <div className="col col-md-2 border font-weight-bold" >Total</div>
          <div className="col col-md-2 border font-weight-bold" align="right">
            {income}
          </div>
          <div className="col col-md-2 border font-weight-bold" align="right">
            {expense}
          </div>
        </div>
      );
    }
  }

  DisplayFilter() {
    return moment(this.props.data.fromDate).format("MMM-YYYY");
  }

  render() {
    return (
      <div>
        <ReportHeader onCloseClick={this.onCloseClick} IsClose="1" />
        <h3 align="center">Monthly Report - {this.DisplayFilter()}</h3>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="container-fluid reportFont">
            <div className="row">
              <div className="col col-md-6 border" align="center">
                <h4>Cash</h4>
              </div>
              <div className="col col-md-3 border" align="center">
                <h4>Opening Balance</h4>
              </div>
              <div className="col col-md-3 border" align="center">
                <h4>Closing Balance</h4>
              </div>
            </div>
            {this.tabCashEntries()}
            {this.tabCashEntriesTotal()}
            <div className="row">&nbsp;</div>
            <div className="row">
              <div className="col col-md-6" align="center">
                <div className="row">
                  <div className="col col-md-12 border" align="center">
                    <h4>Receipts</h4>
                  </div>
                </div>
                {this.tabReceipts()}
                {this.tabReceiptsTotal()}
              </div>
              <div className="col col-md-6" align="center">
                <div className="row">
                  <div className="col col-md-12 border" align="center">
                    <h4>Payments</h4>
                  </div>
                </div>
                {this.tabPayments()}
                {this.tabPaymentsTotal()}
              </div>
            </div>
            {/* <div className="row">&nbsp;</div>
            {this.tabGrandTotal()} */}
            {/* <div className="row">&nbsp;</div>
            <div className="row">
              <div className="col col-md-2 border" align="center">
                <h4>Date</h4>
              </div>
              <div className="col col-md-2 border" align="center">
                <h4>Income</h4>
              </div>
              <div className="col col-md-2 border" align="center">
                <h4>Expense</h4>
              </div>
            </div>
            {this.tabLedgerEntries()}
            {this.tabLedgerTotal()} */}
          </div>
        </div>
      </div>
    );
  }

  onCloseClick = e => {
    this.props.onCloseClick("Filter", null);
  };
}
